/*! @azure/msal-browser v4.25.1 2025-10-17 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.25.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
